import { Routes } from '@/enums/Routes';

export const ALL_USERS_SLUG = 'all-users';

export const ALL_USERS_PATH = Routes.USER_MANAGEMENT_ALL_USERS;

const RESERVED_GROUP_NAMES = new Set(['all-users', 'all users']);

export function isReservedAllUsersGroupName(name: string): boolean {
  return RESERVED_GROUP_NAMES.has(name.trim().toLowerCase());
}

export function isAllUsersPath(pathname: string): boolean {
  return (
    pathname === ALL_USERS_PATH ||
    pathname === `${Routes.USER_MANAGEMENT}/${ALL_USERS_SLUG}`
  );
}
